import { createHead } from '@unhead/vue/client'
import { UserModule } from '~/types/app'

// Unhead https://unhead.unjs.io/
export const install: UserModule = ({ app }) => {
  const head = createHead()
  app.use(head)
}
